module.exports = "<div class=\"weui_progress\">\n  <div class=\"weui_progress_bar\">\n    <div class=\"weui_progress_inner_bar\" :style=\"{width: progress + '%'}\"></div>\n  </div>\n  <a v-if=\"hasCancelButton\" href=\"javascript:;\" class=\"weui_progress_opr\" @click=\"dispatchEvent('weui-progress-cancel')\">\n    <i class=\"weui_icon_cancel\"></i>\n  </a>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/progress/progress.vue
 ** module id = 108
 ** module chunks = 0
 **/